
export interface IApiListItemModel<TAdditionalProps> {
  Label: string;
  Value: string;
  AdditionalProperties: TAdditionalProps;
}

export type ListItemModel = {
  label: string;
  value: string;
};

export const isListItemModel = (arg: any): arg is ListItemModel => arg && arg.label && arg.value;

export type EquipmentDriverListItemModel  = IApiListItemModel<{ EquipmentType: string}>;
